import { createContext, useContext } from 'react'

import type { SelectOption } from '../types'

export type SearchContextValue = {
  searchValue: string
  handleSearchChange: (value: string) => void
  filteredOptions: SelectOption[]
  searchComponent?: React.ReactNode
  hasSearch: boolean
  loading: boolean
}

export const SearchContext = createContext<SearchContextValue | undefined>(undefined)

export const useSearchContext = () => {
  const context = useContext(SearchContext)
  if (!context) throw new Error('useSearchContext must be used within a SearchContext.Provider')
  return context
}
